import { Info } from 'lucide-react';

/**
 * Prototype `.cap-readonly-banner` — left-aligned catalog notice.
 * `@aimsos/ui` `StatusMessage` is a centered empty-state (`py-16`), so this
 * mirrors the prototype callout with tokens instead.
 */
function CapabilitiesCatalogBanner({ title, subtitle, icon: Icon = Info, badge = null }) {
  return (
    <div className="mb-4 flex items-center gap-3.5 rounded-lg border border-[#2B7FFF]/[0.22] bg-[#2B7FFF]/[0.06] px-[18px] py-3.5">
      <div
        aria-hidden="true"
        className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-[#2B7FFF]/[0.12] text-[#2B7FFF]"
      >
        <Icon size={18} strokeWidth={1.8} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="mb-0.5 flex flex-wrap items-center gap-2 text-[13px] font-semibold tracking-[0.01em] text-content">
          {title}
          {badge}
        </div>
        <p className="text-xs leading-normal text-content-secondary">{subtitle}</p>
      </div>
    </div>
  );
}

export default CapabilitiesCatalogBanner;
